export default __webpack_public_path__ + "static/media/paymentFailed.a449ab9f.png";